import { render, staticRenderFns } from "./_promotionDetails.vue?vue&type=template&id=7e1eba86"
import script from "./_promotionDetails.vue?vue&type=script&lang=js"
export * from "./_promotionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports